import React, { useState } from "react";
import Training_Report_Filter from "./training_report_filter/Training_Report_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Training_Report_Table from "./training_report_table/Training_Report_Table";


const Training_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Training_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Training_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Training Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Training_Report;
